import { store } from "../../redux/store";
import { eraseCookie } from "./cookie";
import { getAppendedSchemaName } from "./urls";

let isRedirectingToLogin = false;

export function redirectToLoginOnRefreshFailure() {
  if (isRedirectingToLogin) {
    return;
  }
  isRedirectingToLogin = true;

  localStorage.clear();
  eraseCookie("tokenExpiration");
  eraseCookie("refresh_token");
  eraseCookie("session_key");

  const domainUrl =
    store.getState().authentication?.retailer_info?.response?.domain_url;

  if (domainUrl) {
    const stringToAppend = getAppendedSchemaName();
    window.location.replace(
      `https://${domainUrl}/retailer/dash/${stringToAppend}`
    );
  } else {
    window.location.replace("/access-denied");
  }
}

export function isRetailerAuthRefreshFailed(authState) {
  if (!authState) {
    return false;
  }
  if (authState.hasError) {
    return true;
  }
  if (authState.response?.status === 1) {
    return true;
  }
  const errorType = authState.error?.type || authState.error?.data?.type;
  return errorType === "refresh-invalid";
}
